'use client';
/**
 * `useSdkTurnkey` — thin SDK-owned wrapper around `useTurnkey()` and
 * `useModal()` from `@turnkey/react-wallet-kit`.
 *
 * Lives in `src/platform/web/auth/` because it imports the web-only vendor
 * SDK. Exposes the full Turnkey context value under the SDK's own export
 * boundary so frontend code never imports `@turnkey/react-wallet-kit` directly.
 *
 * Also re-exports `KeyFormat` from the vendor SDK (a const-enum used by
 * import/export wallet flows) as `SdkKeyFormat`.
 *
 * Auth cutover — spec 009 FILE 14, Groups B/D/E.
 * Verified against `@turnkey/react-wallet-kit` v2 (Turnkey docs MCP, 2026-05-20).
 */
import { KeyFormat, OtpType, useModal, useTurnkey } from '@turnkey/react-wallet-kit';
/** Re-exported so frontend never imports from `@turnkey/react-wallet-kit` directly. */
export { KeyFormat as SdkKeyFormat, OtpType as SdkOtpType };
/**
 * Returns the Turnkey context plus modal helpers.
 *
 * Must be called inside the `<TurnkeyProvider>` tree (i.e. inside the SDK's
 * `<SdkTurnkeyWebProvider>`). Components that only need `handleLogin` or
 * session/user state should destructure just what they need.
 */
export function useSdkTurnkey() {
    const tk = useTurnkey();
    const { closeModal } = useModal();
    return { ...tk, closeModal };
}
//# sourceMappingURL=use-sdk-turnkey.js.map